/* Sailor LP — comportamento das seções sailor-lp-*.
   Cada seção se inicia pelo atributo data-slp="<tipo>"; o editor de tema recarrega a seção e dispara
   shopify:section:load, então tudo é idempotente por raiz. A sacola é a do tema (theme.js escuta
   [data-btn-addtocart] e abre a gaveta). */
(function () {
  'use strict';
  // cada seção inclui este arquivo; roda uma vez só
  if (window.SailorLP) return;
  window.SailorLP = true;

  var $$ = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- contagem regressiva ---------- */
  function initCountdown(root) {
    $$(root, '[data-slp-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-slp-countdown'));
      if (isNaN(end)) { el.hidden = true; return; }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
          m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var tick = function () {
        var left = Math.max(0, end - Date.now());
        if (!left) {
          el.hidden = true;
          var over = el.parentNode.querySelector('[data-slp-countdown-over]');
          if (over) over.hidden = false;
          clearInterval(el._slpTimer);
          return;
        }
        var sec = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor(sec % 86400 / 3600));
        m.textContent = pad(Math.floor(sec % 3600 / 60));
        s.textContent = pad(sec % 60);
      };
      clearInterval(el._slpTimer);
      el.hidden = false;
      tick();
      el._slpTimer = setInterval(tick, 1000);
    });
  }

  /* ---------- barra de lote ---------- */
  function initBars(root) {
    $$(root, '[data-slp-bar]').forEach(function (bar) {
      var pct = Math.min(100, Math.max(0, parseFloat(bar.getAttribute('data-slp-bar')) || 0));
      var fill = function () { bar.style.width = pct + '%'; };
      if (!('IntersectionObserver' in window)) return fill();
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { fill(); io.disconnect(); }
      });
      io.observe(bar);
    });
  }

  /* ---------- carrossel (scroll nativo) ---------- */
  function initCarousels(root) {
    $$(root, '[data-slp-car]').forEach(function (car) {
      var track = car.querySelector('[data-slp-track]');
      if (!track) return;
      var step = function (dir) {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      $$(car, '[data-slp-prev]').forEach(function (b) { b.onclick = function () { step(-1); }; });
      $$(car, '[data-slp-next]').forEach(function (b) { b.onclick = function () { step(1); }; });
      // setas só quando há o que rolar
      var nav = car.querySelector('.slp-car__nav');
      var fit = function () { if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 2; };
      fit();
      window.addEventListener('resize', fit, { passive: true });
    });
  }

  /* ---------- modal ---------- */
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.classList.add('is-open');
    var x = modal.querySelector('[data-slp-modal-close]');
    if (x) x.focus();
  }
  function closeModals() {
    $$(document, '.slp-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-slp-modal-open]');
    if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-slp-modal-open')); return; }
    if (e.target.closest('[data-slp-modal-close]') || e.target.classList.contains('slp-modal')) closeModals();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

  /* ---------- buy box ---------- */
  function initBuy(root) {
    var box = root.querySelector('[data-slp-buy]');
    if (!box) return;
    var json = box.querySelector('[data-slp-variants]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var form = box.querySelector('form');
    var idInput = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var atc = form.querySelector('[data-btn-addtocart]');
    var now = form.querySelector('[data-slp-buynow]');
    var optCount = parseInt(box.getAttribute('data-options'), 10) || 0;
    var lowStock = parseInt(box.getAttribute('data-low-stock'), 10) || 0;
    var txt = {
      add: box.getAttribute('data-t-add'),
      choose: box.getAttribute('data-t-choose'),
      soldout: box.getAttribute('data-t-soldout'),
      low: box.getAttribute('data-t-low')
    };
    var selected = [];
    var preset = variants.filter(function (v) { return String(v.id) === idInput.value; })[0];
    if (preset) selected = preset.options.slice();

    var find = function () {
      if (selected.filter(function (x) { return x != null; }).length < optCount) return null;
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0] || null;
    };
    var set = function (sel, html) {
      $$(root, sel).forEach(function (el) { el.innerHTML = html || ''; el.hidden = !html; });
    };

    var slides = $$(root, '[data-slp-slide]');
    var thumbs = $$(root, '[data-slp-thumb]');
    var show = function (i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var v = slides[i].querySelector('video');
      $$(root, '[data-slp-slide] video').forEach(function (x) { if (x !== v) x.pause(); });
      root._slpSlide = i;
    };
    thumbs.forEach(function (t, k) { t.onclick = function () { show(k); }; });
    $$(root, '[data-slp-gal]').forEach(function (b) {
      b.onclick = function () { show((root._slpSlide || 0) + parseInt(b.getAttribute('data-slp-gal'), 10)); };
    });
    show(0);

    var render = function () {
      var v = find();
      $$(root, '[data-slp-opt]').forEach(function (b) {
        var i = parseInt(b.getAttribute('data-slp-opt'), 10), val = b.getAttribute('data-value');
        b.classList.toggle('is-active', selected[i] === val);
        // valor esgotado considerando só as opções ANTERIORES (cor não depende do tamanho; tamanho depende da cor)
        var ok = variants.some(function (x) {
          return x.available && x.options[i] === val && x.options.every(function (o, k) {
            return k >= i || selected[k] == null || o === selected[k];
          });
        });
        b.classList.toggle('is-out', !ok);
      });
      $$(root, '[data-slp-sel]').forEach(function (el) {
        el.textContent = selected[parseInt(el.getAttribute('data-slp-sel'), 10)] || '';
      });
      var ref = v || variants.filter(function (x) { return x.available; })[0] || variants[0];
      if (ref) {
        set('[data-slp-price]', ref.price);
        set('[data-slp-compare]', ref.compare);
        set('[data-slp-inst]', ref.inst);
        set('[data-slp-pix]', ref.pix);
      }
      set('[data-slp-sku]', v && v.sku ? v.sku : '');
      var stock = '';
      if (v && !v.available) stock = txt.soldout;
      else if (v && v.managed && lowStock && v.qty > 0 && v.qty <= lowStock) stock = txt.low.replace('[n]', v.qty);
      set('[data-slp-stock]', stock);

      if (v) idInput.value = v.id;
      var can = !!(v && v.available);
      atc.disabled = !can;
      if (now) now.disabled = !can;
      atc.querySelector('span').textContent = !v ? txt.choose : (v.available ? txt.add : txt.soldout);
      if (qty && v && v.managed && v.qty > 0 && !v.continue) qty.max = v.qty; else if (qty) qty.removeAttribute('max');
      if (v && v.media != null) {
        var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.media));
        if (idx > -1) show(idx);
      }
      // barra fixa espelha o último seletor (tamanho) da buy box
      $$(document, '[data-slp-sticky-opt]').forEach(function (b) {
        var twin = root.querySelector('[data-slp-opt="' + (optCount - 1) + '"][data-value="' + CSS.escape(b.getAttribute('data-value')) + '"]');
        b.classList.toggle('is-active', selected[optCount - 1] === b.getAttribute('data-value'));
        b.classList.toggle('is-out', !!twin && twin.classList.contains('is-out'));
      });
    };

    $$(root, '[data-slp-opt]').forEach(function (b) {
      b.onclick = function () {
        selected[parseInt(b.getAttribute('data-slp-opt'), 10)] = b.getAttribute('data-value');
        render();
      };
    });
    $$(root, '[data-slp-qty]').forEach(function (b) {
      b.onclick = function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-slp-qty'), 10);
        var max = parseInt(qty.max, 10) || 99;
        qty.value = Math.min(max, Math.max(1, n));
      };
    });
    render();

    /* barra fixa: fica fora do box, na mesma seção */
    var sticky = root.querySelector('[data-slp-sticky]');
    if (sticky) {
      if (sticky.parentNode !== document.body) {
        var old = document.getElementById(sticky.id);
        if (old && old !== sticky) old.parentNode.removeChild(old);
        document.body.appendChild(sticky);
      }
      $$(sticky, '[data-slp-sticky-opt]').forEach(function (b) {
        b.onclick = function () {
          var target = root.querySelector('[data-slp-opt="' + (optCount - 1) + '"][data-value="' + CSS.escape(b.getAttribute('data-value')) + '"]');
          if (target) target.click();
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
      });
      var go = sticky.querySelector('[data-slp-sticky-go]');
      if (go) go.onclick = function (e) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      // mostra depois que a compra saiu por cima da tela; checa na rolagem (IntersectionObserver
      // não dispara em saltos de âncora/voltar ao topo, e a barra ficava presa)
      var ticking = false;
      var check = function () {
        ticking = false;
        var on = box.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-show', on);
        document.body.classList.toggle('slp-sticky-on', on);
      };
      if (root._slpScroll) window.removeEventListener('scroll', root._slpScroll);
      root._slpScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', root._slpScroll, { passive: true });
      check();
    }
  }

  /* ---------- anatomia da estampa ---------- */
  function initAnatomy(root) {
    if (!root.querySelector('[data-slp-tab]') && !root.querySelector('[data-slp-hs]')) return;
    var view = function (name) {
      $$(root, '[data-slp-tab]').forEach(function (t) {
        var on = t.getAttribute('data-slp-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on);
      });
      $$(root, '[data-slp-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-slp-panel') === name); });
    };
    var pick = function (id) {
      $$(root, '[data-slp-hs],[data-slp-hs-item]').forEach(function (el) {
        el.classList.toggle('is-active', (el.getAttribute('data-slp-hs') || el.getAttribute('data-slp-hs-item')) === id);
      });
    };
    $$(root, '[data-slp-tab]').forEach(function (t) {
      t.onclick = function () {
        var name = t.getAttribute('data-slp-tab');
        view(name);
        var first = root.querySelector('[data-slp-panel="' + name + '"] [data-slp-hs-item]');
        if (first) pick(first.getAttribute('data-slp-hs-item'));
      };
    });
    $$(root, '[data-slp-hs],[data-slp-hs-item]').forEach(function (el) {
      el.onclick = function () { pick(el.getAttribute('data-slp-hs') || el.getAttribute('data-slp-hs-item')); };
    });
    root._slpAnat = { view: view, pick: pick };
  }

  /* ---------- formulário (FormSubmit por AJAX: não sai da página) ---------- */
  function initForm(root) {
    var form = root.querySelector('[data-slp-form]');
    if (!form) return;
    var btn = form.querySelector('[data-slp-form-submit]');
    var msg = form.querySelector('[data-slp-form-msg]');
    var ok = root.querySelector('[data-slp-form-ok]');
    var endpoint = form.getAttribute('data-endpoint');

    var invalid = function (el) {
      if (el.type === 'checkbox') return !el.checked;
      var v = (el.value || '').trim();
      if (!v) return true;
      if (el.type === 'email') return !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v);
      if (el.type === 'tel') return (v.replace(/\D/g, '').length < 10);
      return false;
    };

    $$(form, '[data-required]').forEach(function (el) {
      el.addEventListener('blur', function () { el.closest('.slp-form__field, .slp-form__consent').classList.toggle('is-invalid', invalid(el)); });
      el.addEventListener('input', function () { el.closest('.slp-form__field, .slp-form__consent').classList.remove('is-invalid'); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = 0;
      $$(form, '[data-required]').forEach(function (el) {
        var wrap = el.closest('.slp-form__field, .slp-form__consent');
        var v = invalid(el);
        if (wrap) wrap.classList.toggle('is-invalid', v);
        if (v && !bad++) el.focus();
      });
      if (bad) return;
      if (form.querySelector('[name="_honey"]').value) return; // robô

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-sending') || label;
      if (msg) msg.hidden = true;

      var data = {};
      new FormData(form).forEach(function (v, k) { if (k !== '_honey') data[k] = v; });

      fetch('https://formsubmit.co/ajax/' + encodeURIComponent(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) { return r.json(); })
        .then(function (r) {
          if (String(r.success) !== 'true') throw new Error(r.message || 'erro');
          form.hidden = true;
          if (ok) { ok.hidden = false; ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
          if (msg) { msg.textContent = root.getAttribute('data-error') || msg.getAttribute('data-error') || 'Não conseguimos enviar agora. Tente de novo em instantes.'; msg.hidden = false; }
        });
    });

    // link "adicionar à agenda" (Google Agenda)
    var cal = root.querySelector('[data-slp-cal]');
    if (cal) {
      var fmt = function (iso) {
        var d = new Date(iso);
        return isNaN(d) ? '' : d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      };
      var ini = fmt(cal.getAttribute('data-start')), fim = fmt(cal.getAttribute('data-end'));
      if (!ini) cal.hidden = true;
      else {
        cal.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
          + '&text=' + encodeURIComponent(cal.getAttribute('data-title') || '')
          + '&dates=' + ini + '/' + (fim || ini)
          + '&details=' + encodeURIComponent(cal.getAttribute('data-details') || '')
          + '&location=' + encodeURIComponent(cal.getAttribute('data-location') || '');
      }
    }
  }

  var inits = {
    hero: function (r) { initCountdown(r); initBars(r); },
    form: function (r) { initBars(r); initForm(r); },
    buy: initBuy,
    anatomy: initAnatomy,
    carousel: initCarousels
  };
  function init(scope) {
    $$(scope, '[data-slp]').concat(scope.matches && scope.matches('[data-slp]') ? [scope] : []).forEach(function (root) {
      root.getAttribute('data-slp').split(' ').forEach(function (k) { if (inits[k]) inits[k](root); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$(document, '[data-slp-sticky][data-section="' + e.detail.sectionId + '"]').forEach(function (s) { s.parentNode.removeChild(s); });
  });
  // no editor, selecionar um ponto da anatomia mostra a vista e o ponto
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var sec = el.closest('[data-slp~="anatomy"]');
    if (!sec || !sec._slpAnat) return;
    var id = el.getAttribute('data-slp-hs-item');
    var panel = el.closest('[data-slp-panel]');
    if (panel) sec._slpAnat.view(panel.getAttribute('data-slp-panel'));
    if (id) sec._slpAnat.pick(id);
  });
})();
